export const NOOP_ERROR_HANDLER = () => {
  return;
};
